import AnalyticFields from '../../enums/AnalyticFields';

export default function getDimensions(accountId) {
  if (!accountId) return [];
  const { City, Country, State } = AnalyticFields;

  return [
    `${accountId}.${City.name}`,
    `${accountId}.${Country.name}`,
    `${accountId}.${State.name}`,
  ];
}
